import React, {useState} from "react";
import {useLanguage} from "../../../hooks/LanguageContext";
import {Button} from "../../index";
import apiService from "../../../services/apiService";
import {useNavigate} from "react-router-dom";

const TrackOrderForm = () => {
	const { direction } = useLanguage(); // Access the language direction (rtl or ltr)
	const navigate = useNavigate();
	const [shippingNumber,setShippingNumber] = useState("");
	const [error,setError] = useState(false)

	const handleOnSubmit = (event) => {
		event.preventDefault();
		if (shippingNumber.length) {
			apiService
				.getShipmentTracking(shippingNumber)
				.then((response) => {
					if (response.data.waybill_id) {
						navigate(`/tracking/${response.data.waybill_code}`)
					}
					else setError(true)
				})
				.catch((err) => {
					setError(true)
				});
		}
	};

	return (
		<div className={`w-full  flex flex-col items-start ${direction === "rtl" ? "md:gap-8" : "md:gap-4"} z-[2]`}>
			<h3 className={`headline-3-ar text-grayscale-600`}>
				{direction === "rtl"
					? "تتبع سيارتك من خلال رقم بوليصه الشحن..."
					: "Track your vehicle using the shipping number..."}
			</h3>


			<div className={`mt-2 font-bold md:text-xl lg:text-2xl text-primary-600 cursor-pointer`}>
				{direction === "rtl" ? "ادخل رقم بوليصة الشحن او رقم جوال المستلم" : "Enter Receiver's Phone Number or Shipping Number"}
			</div>


			<form
				onSubmit={handleOnSubmit}
				className="md:w-[700px] w-full md:h-[95px] h-14 mt-4 flex justify-between items-center py-[20px] md:px-[30px]  shadow-custom-shadow rounded-md"
			>
				<div className="md:w-[600px] w-full md:h-[50px] h-10 flex justify-between items-center">
					<input
						className={`font-bold placeholder-ar w-full h-full p-1  text-sm md:text-lg  `}
						type="text"
						onChange={(e) => setShippingNumber(e.target.value)}
						placeholder={direction === "rtl" ? "ادخل رقم بوليصة الشحن او رقم جوال المستلم" :
							"Enter Receiver's Phone Number or Shipping Number"}
					/>
					<Button className=" md:rounded-[13px] rounded-lg">
						{direction === "rtl" ? "بحث" : "Search"}
					</Button>

				</div>
			</form>

			<div className="mt-2 font-bold md:text-xl text-primary-600 cursor-pointer">
				{error && (
					<span>
           				 {direction === "rtl" ? "لم يتم العثور على شحنة بهذا الرقم" : "No shipment with this number found"}
       				 </span>
				)}
			</div>


		</div>
	);
};

export default TrackOrderForm;
